import React, { Component } from 'react';

class GDTR extends Component {
  render() {
    return (
      <div>
        <a href="" className="btn btn-sm btn-info-outline text-secondary mt-2" data-toggle="modal" data-target="#staticBackdropGDTR">
          GDTR
        </a>
        <div
          className="modal fade"
          id="staticBackdropGDTR"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabelGDTR"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title text-info" id="staticBackdropLabelGDTR">
                  GDTR
                </h5>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body text-dark">
                <ul className="list-group">
                  <li className="list-group-item">
                  Nettsiden smedenisund.no/nettbutikk sparer ingen cookies eller øvrig brukerdata, men betalningstjenesten PayPal gjør det for å hantere funksjonaliteten med handlekurv med mere. Når du videreføres til PayPal vil du bli opplyst om dette. Smeden i Sund har ikke tilgang til informasjonen fra betalningskort ved kjøp. Adresse og e-post spares for å hantere levering, eventuell kundesupport og for å oppfylle regnskapskrav. Ved abonnering på nyhetsbrevet spares e-post-adressen frem til abonnementet avsluttes.
                  </li>
                  {/* <li className="list-group-item">
                    Velg den <strong>grå knappen</strong> for normal kortbetalning.
                  </li>
                  <li className="list-group-item text-danger">
                    Du behøver <strong>ikke</strong> registrere deg på PayPal.
                  </li> */}
                </ul>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal">
                  Skjønner
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GDTR;
